"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); } // +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var contentRouter = {
  path: '/applet',
  component: _layout.default,
  redirect: '/applet/companyapp',
  name: 'applet',
  meta: {
    title: '小程序装修',
    icon: 'clipboard'
  },
  children: [{
    path: 'companyapp',
    name: 'companyapp',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/applet/setting/companyapp'));
      });
    },
    meta: {
      title: '小程序列表',
      icon: ''
    }
  }, {
    path: 'pageList',
    name: 'pageList',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/applet/setting/pageList'));
      });
    },
    meta: {
      title: '装修页列表',
      icon: ''
    }
  }, {
    name: 'decorationPage',
    path: 'decorationPage:id?',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/applet/setting/decorationPage'));
      });
    },
    meta: {
      title: '装修页面',
      icon: '',
      activeMenu: "/applet/pageList"
    },
    hidden: true
  }, {
    name: 'skinSetting',
    path: 'skinSetting:id?',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/applet/setting/skinSetting'));
      });
    },
    meta: {
      title: '装修页面',
      icon: '',
      activeMenu: "/applet/pageList"
    },
    hidden: true
  }, {
    path: 'jumpNav',
    name: 'jumpNav',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/applet/setting/jumpNav'));
      });
    },
    meta: {
      title: '链接管理',
      icon: ''
    }
  }, {
    path: 'skinForm',
    name: 'skinForm',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/applet/setting/skinForm'));
      });
    },
    meta: {
      title: '表单管理',
      icon: ''
    }
  }, {
    path: 'skinForm/editForm/:id?',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/applet/setting/skinForm/editForm'));
      });
    },
    name: 'SortCreat',
    meta: {
      title: '表单设置',
      noCache: true,
      activeMenu: "/applet/skinForm"
    },
    hidden: true
  }, {
    path: 'questionList',
    name: 'questionList',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/applet/setting/questionList'));
      });
    },
    meta: {
      title: '常见问题管理',
      icon: ''
    }
  }, {
    path: 'activityList',
    name: 'activityList',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/applet/setting/activityList'));
      });
    },
    meta: {
      title: '活动管理',
      icon: ''
    }
  }, {
    path: 'specialty',
    name: 'specialty',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/applet/setting/specialty'));
      });
    },
    meta: {
      title: '地区特产专区',
      icon: ''
    }
  }, {
    path: 'specialty/editSpec/:id?',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/applet/setting/specialty/editSpec'));
      });
    },
    name: 'SortCreat',
    meta: {
      title: '配置地区特产专区',
      noCache: true,
      activeMenu: "/applet/specialty"
    },
    hidden: true
  }, {
    path: 'mealList',
    name: 'mealList',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/applet/setting/mealList'));
      });
    },
    meta: {
      title: '套餐页面管理',
      icon: ''
    }
  }, {
    path: 'mealList/editMeal/:id?',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/applet/setting/mealList/editMeal'));
      });
    },
    name: 'SortCreat',
    meta: {
      title: '设置组合套餐',
      noCache: true,
      activeMenu: "/applet/mealList"
    },
    hidden: true
  }, {
    path: 'decoration',
    name: 'decoration',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/applet/setting/decoration'));
      });
    },
    meta: {
      title: '页面配置',
      icon: ''
    }
  }]
};
var _default = exports.default = contentRouter;